import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-conmet-select',
  styleUrls: ['./conmet-select.component.scss'],
  template: `
    <div class='d-flex'>
      <label *ngIf='label'>{{ label }}</label>
      <label *ngIf='!label'>&nbsp;</label>
    </div>
    <div class='d-flex' [formGroup]='group'>
      <!--{{group.controls[formname].value}}-->
      <select class='form-control {{validationCheckFunc()}}' [formControlName]='formname'
              [attr.placeholder]='label' [attr.disabled]="disabled" (change)="emitChangeEvent()">
        <option value="0" *ngIf="vuoto === 1">----</option>
        <option *ngFor="let a of arr" [value]="a[val]">{{a[descr]}}</option>  <!-- {{a[val]}} -  -->
      </select>
    </div>
  `
})
export class ConmetSelectComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() label: string;
  @Input() formname: string;
  @Input() arr: Array<any>;
  @Input() val: string;
  @Input() descr: string;
  @Input() vuoto: number;
  @Input() validation: boolean;
  @Input() validationCheck: boolean;

  @Output() changeEvent = new EventEmitter<any>();

  @Input()
  set disable(campo: boolean) {
    if (campo) {
      this.disabled = campo;
    } else {
      this.disabled = null;
    }
  }

  disabled: boolean;

  constructor() {
    this.disabled = null;
    this.vuoto = 0;
  }

  ngOnInit() {
  }

  validationCheckFunc() {
    if (this.validation) {
      return this.validationCheck ? 'is-valid' : 'is-invalid';
    }

    return '';
  }

  emitChangeEvent() {
    this.changeEvent.emit(this.group.value[this.formname]);
  }
}
